<template>
	<div class="wrap">
		<div class="page_title"><b>菜单管理</b></div>
		<div class="main public_box">
			<menu-admin-hl></menu-admin-hl>
		</div>
	</div>
</template>

<script> 
// @ is an alias to /src   
import MenuAdminHl from '@/package/menuAdminHl/index.vue'
export default {
	name: 'menuAdmin',
	components: {
		MenuAdminHl
	},
	data(){
		return{
			loading:false,
			menuType:'searchReviewPage'
		}
	},
	methods:{
		
	},
	mounted() {  // 

	}
}
</script>
<style scoped>
	.main{
		margin-top: 0.2rem;
	}
</style>
